<div class="search-cities-input">
  <ng-container *tuiLet="topCities$ | async as topCities">
    <ng-container *tuiLet="searchCities$ | async as searchCities">
      <tui-select
        *ngIf="mode === 'single'"
        [class.tui-skeleton]="loading"
        [class.tui-skeleton_text]="loading"
        [tuiTextfieldSize]="textfieldSize"
        [tuiTextfieldLabelOutside]="textfieldLabelOutside"
        [stringify]="stringify"
        [identityMatcher]="matcher"
        [tuiTextfieldCleaner]="textfieldCleaner"
        [disabled]="disabled"
        [pseudoInvalid]="touched && invalid"
        [ngModel]="getValue()"
        (ngModelChange)="setValue($event)"
      >
        <ng-container *ngTemplateOutlet="contentTmp"></ng-container>

        <ng-template tuiDataList>
          <ng-container *ngTemplateOutlet="searchTmp"></ng-container>

          <tui-data-list [size]="'l'">
            <tui-opt-group
              *ngIf="searchCities || topCities as items; else skeletonTmp"
              [label]="
                searchCities
                  ? ('components.searchCitiesInput.labels.searchResults' | translate)
                  : ('components.searchCitiesInput.labels.topCities' | translate)
              "
            >
              <button *ngFor="let item of items" tuiOption [value]="item">
                <ng-container *ngTemplateOutlet="renderRowTmp; context: { $implicit: item }"></ng-container>
              </button>
            </tui-opt-group>
          </tui-data-list>
        </ng-template>
      </tui-select>

      <tui-multi-select
        *ngIf="mode === 'multiple'"
        [class.tui-skeleton]="loading"
        [class.tui-skeleton_text]="loading"
        [rows]="3"
        [tuiTextfieldSize]="textfieldSize"
        [tuiTextfieldLabelOutside]="textfieldLabelOutside"
        [stringify]="stringify"
        [identityMatcher]="matcher"
        [tuiTextfieldCleaner]="textfieldCleaner"
        [(ngModel)]="value"
        [disabled]="disabled"
        [pseudoInvalid]="touched && invalid"
        [editable]="false"
      >
        <ng-container *ngTemplateOutlet="contentTmp"></ng-container>

        <ng-template tuiDataList>
          <ng-container *ngTemplateOutlet="searchTmp"></ng-container>

          <tui-data-list>
            <tui-opt-group tuiMultiSelectGroup>
              <button tuiOption [value]="allCities" (click)="setAllCities()">{{ allCities.city }}</button>
            </tui-opt-group>

            <tui-opt-group
              *ngIf="searchCities || topCities as items; else skeletonTmp"
              tuiMultiSelectGroup
              [label]="
                searchCities
                  ? ('components.searchCitiesInput.labels.searchResults' | translate)
                  : ('components.searchCitiesInput.labels.topCities' | translate)
              "
            >
              <button *ngFor="let item of items" tuiOption [value]="item" size="l" (click)="deleteAllCities()">
                <ng-container *ngTemplateOutlet="renderRowTmp; context: { $implicit: item }"></ng-container>
              </button>
            </tui-opt-group>
          </tui-data-list>
        </ng-template>
      </tui-multi-select>
    </ng-container>
  </ng-container>
</div>

<ng-template #contentTmp>
  <ng-content></ng-content>
</ng-template>

<ng-template #searchTmp>
  <app-search class="search" [(searchQuery)]="searchQuery" (searchQueryChange)="onSearchChange($event)"></app-search>
</ng-template>

<ng-template #renderRowTmp let-item>
  <render-city-row [city]="item"></render-city-row>
</ng-template>

<ng-template #skeletonTmp>
  <app-skeleton-wrapper [loading]="true"></app-skeleton-wrapper>
</ng-template>
